import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { loadApplications } from '../../redux/appList/actions'
import ApplicationList from 'components/ApplicationList'
import ModalCreateApplication from 'components/ApplicationList/modal'

class AppList extends React.Component {
    constructor(props) {
        super(props)
        this.state = { visibleModal: false }
    }
    componentDidMount() {
        const { loadApplications } = this.props

        loadApplications()
    }

    onCreateApp = () => {
        this.setState({ visibleModal: true })
    }

    handleCloseModal = () => {
        this.setState({ visibleModal: false })
    }

    render() {
        const { loading, applicationList } = this.props

        return (
            <div>
                <ApplicationList appList={applicationList} loading={loading} onCreateApp={this.onCreateApp} />
                <ModalCreateApplication visible={this.state.visibleModal} onClose={this.handleCloseModal} />
            </div>
        )
    }
}

const mapStateToProps = ({ appList }) => ({
    applicationList: appList.applicationList,
    loading: appList.loadingApplications
})

const mapActionsToProps = dispatch => ({
    loadApplications: bindActionCreators(loadApplications, dispatch)
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(AppList)
